import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';

@Component({
  selector: 'shop-and-ship-to-country-price-calculation',
  templateUrl: 'price-calculation-to-country.component.html',
  styleUrls: ['price-calculation-to-country.component.css'],
})
export class ShopAndShipPriceCalculationToCountryComponent implements OnInit, OnChanges {
  lang: string;
  fromCountryCode: string = 'US';
  @Input() countryCode: string;
  priceCalculationForm: FormGroup;
  showCountrySelection: boolean = false;
  showFromCountrySelection: boolean = false;
  priceCalculationResultData: any[] = [];
  countriesList: any[] = [];
  fromCountriesList: any[] = [];
  constructor(
    private _fb: FormBuilder, private signupService: SignupService, private toastr: ToastrService, private _router: Router, private watcherService: WatcherService) {
    this.priceCalculationForm = this._fb.group({
      fromCountry: ['US', Validators.required],
      toCountry: ['', Validators.required],
      toCity: [''],
      postalCode: ['', Validators.required],
      packageValue: ['', [Validators.required, Validators.min(0.1)]],
      weight: ['', [Validators.required, Validators.min(0.5)]],
      weightUnit: ['lb', Validators.required],
      length: ['', [Validators.required, Validators.min(0.5)]],
      width: ['', [Validators.required, Validators.min(0.5)]],
      height: ['', [Validators.required, Validators.min(0.5)]],
      dimensionsUnit: ['in', Validators.required],
    });
  }

  selectedCountry: any;
  selectedFromCountry: any;
  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
    this.signupService.getAllCountries().subscribe({
      next: (response) => {
        this.countriesList = response['data'];
        this.fromCountriesList = this.countriesList.filter(
          (country) => country.code !== this.countryCode
        );
        this.priceCalculationForm.patchValue({
          fromCountry: this.fromCountryCode
        });
         this.countriesList?.find(
          (country) => country.code.toLowerCase() === this.fromCountryCode.toLowerCase()
        );

        if (this.countryCode === 'US'){
          this.fromCountryCode = 'UK';
        }
        
        
        this.selectFromCountry(this.fromCountryCode);
        this.selectToCountry(this.countryCode);
      },
      error: (err) => { },
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.countryCode) {
      this.selectToCountry(this.countryCode);
    }
  }

  onSubmit() {

    if (!this.checkFormValues()) {
      this.calculatePrice();
    } else {
      this.toastr.error('Please fill all the required fields!');
    }
  }
  focusLost(from: boolean = false) {
    if (from) {
      this.showFromCountrySelection = false;
    } else {
      this.showCountrySelection = false;
    }
  }
  selectToCountry(code) {
    this.selectedCountry = this.countriesList.find(
      (country) => country.code === code
    );
    this.priceCalculationForm.patchValue({
      toCountry: code
    });
    this.showCountrySelection = false;
  }

  selectFromCountry(code) {
    this.selectedFromCountry = this.countriesList.find(
      (country) => country.code === code
    );
    this.priceCalculationForm.patchValue({
      fromCountry: code
    });
    this.showFromCountrySelection = false;
  }

  checkFormValues() {
    let hasError = false;
    if (!this.priceCalculationForm.controls['toCountry'].value) {
      hasError = true;
    }
    if (!this.priceCalculationForm.controls['length'].value || this.priceCalculationForm.controls['length'].value == 0) {
      hasError = true;
    }
    if (!this.priceCalculationForm.controls['width'].value || this.priceCalculationForm.controls['width'].value == 0) {
      hasError = true;
    }
    if (!this.priceCalculationForm.controls['height'].value || this.priceCalculationForm.controls['height'].value == 0) {
      hasError = true;
    }
    if (!this.priceCalculationForm.controls['weight'].value || this.priceCalculationForm.controls['weight'].value == 0) {
      hasError = true;
    }
    return hasError;
  }

  calculatePrice() {
    const payload = {
      country_from: this.priceCalculationForm.controls['fromCountry'].value,
      country_to: this.priceCalculationForm.controls['toCountry'].value,
      dimension: {
        length: parseFloat(this.priceCalculationForm.controls['length'].value),
        width: parseFloat(this.priceCalculationForm.controls['width'].value),
        height: parseFloat(this.priceCalculationForm.controls['height'].value),
        dimension_unit:
          this.priceCalculationForm.controls['dimensionsUnit'].value == 'in'
            ? 'inch'
            : 'cm',
        weight: parseFloat(this.priceCalculationForm.controls['weight'].value),
        weight_unit:
          this.priceCalculationForm.controls['weightUnit'].value == 'lb'
            ? 'lbs'
            : 'kg',
      },
    };
    this.signupService.calculatePackagePrice('', payload).subscribe({
      next: (response) => {
        if (response['result']['status'] === 200) {
          this.priceCalculationResultData = response['data']['shipment_amount'];
        } else {
          this.toastr.error(response['result']['message']);
        }

      },
      error: (err) => {
        this.toastr.error('Something went wrong!');
      },
    });
  }

  // Number Input Fixes
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedInput: string = clipboardData.getData('text');
    const sanitizedInput: string = this.sanitizeInput(pastedInput);
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = sanitizedInput;
  }

  sanitizeInput(input: string): string {
    const sanitizedInput = input.replace(/\s+/g, '').replace(/[^0-9.,]/g, '');
    return sanitizedInput
      ? parseFloat(sanitizedInput.replace(',', '.')).toFixed(2)
      : '';
  }
  checkKey(event: KeyboardEvent): void {
    const keyCode = event.key;
    const inputValue = (event.target as HTMLInputElement).value;
    const decimalCount = inputValue.split('.').length - 1;
    const allowedCharacters =
      /[0-9.\b]|Delete|Backspace|ArrowLeft|ArrowRight|ArrowUp|ArrowDown/;
    if (!allowedCharacters.test(keyCode)) {
      event.preventDefault();
      return;
    }

    if (keyCode === '.' && decimalCount >= 1) {
      event.preventDefault();
    }
  }
  checkValue(event: any) {
    const inputValue = event.target.value;
    if (inputValue === null || inputValue === '' || isNaN(inputValue)) {
      event.target.value = '0';
    }
  }
  goToSignUp() {
    this._router.navigateByUrl(`/${this.lang}/signup/`)
  }
}
